module.exports = __webpack_public_path__ + "17fef7ce2074ba7fcd91c6300ae4ba28.svg";